<template>
  <div>
    <b-row no-gutters>
      <b-col md="8" class="head-card">
        <b-card class="bg-t-dark-- m-1">
          <b-row>
            <b-col>
              <h5 id="map-title">{{$t("Equipments by location")}}</h5>
            </b-col>
          </b-row>
          <Map/>
        </b-card>
      </b-col>
      <b-col md="4" class="head-card">
          <Notifications/>
      </b-col>
    </b-row>
    <b-row no-gutters class="mt-4">
      <b-col md="5" class="main-card">
        <DashboardBarChart/>
      </b-col>
      <b-col md="7" class="main-card">
        <b-card class="bg-t-dark-- m-1">
          <Orders/>
        </b-card>
      </b-col>
    </b-row>
    <br>
  </div>
</template>

<script>
import DashboardBarChart from "./components/DashboardBarChart"
import Notifications from "./components/Notifications"
import Orders from "./components/Orders"
import Map from "./components/Map"

export default {
  components:{
    DashboardBarChart,
    Notifications,
    Orders,
    Map,
  },
  mounted(){
    this.$store.commit('set_logged', true)
  },
  data(){
    return{
    }
  }
}
</script>

<style lang="scss">
  @media only screen and (min-width: 600px) {
    .head-card{
      .card{
        height: 450px;
        overflow-y: hidden;
      }
      .notifications-card{
        .card-body{
          overflow-y: auto !important;
        }
      }
    }
    .main-card{
      .card{
        height: 100%;
      }
    }
  }
</style>